import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { toCamel } from 'snake-camel';



@Component({
    components: {
        Modal,
    }
})
export default class NotificationPreviewModal extends Vue {
    
    @Prop() isShowNotificationPreviewModal!: boolean
    
    @Prop() notificationTitle!: string

    @Prop() notificationPublishDate!: string

    @Prop() isImportant!: string

    @Prop() notificationContent!: string

  
    // @Watch('isShowNotificationPreviewModal')
    // private showNotifications() {
    //     console.log("first",this.notificationTitle);
    //     if(this.isShowNotificationPreviewModal){

    //         // this.getNotifications(this.isImportantOnly)
    //         // this.isActive(this.notificationId);
    //     }
    // }

    convertToHTML(content:string) {
      // Define the regular expression pattern
      const pattern = /<@@URL>(.*?)<&&>(.*?)<\/@@URL>/gs;

      // Replace each occurrence of the pattern with HTML
      const convertedContent = content.replace(pattern, (match, url, label) => {
        // Create a hyperlink element
        const hyperlink = document.createElement('a');
        hyperlink.href = url;
        hyperlink.textContent = label;
        hyperlink.target = '_blank'; // Open link in a new tab

        // Return the HTML content
        return hyperlink.outerHTML;
      });
      // Preserve line breaks in the content
      const preservedContent = convertedContent.replace(/\n/g, '<br>');

     // Return the final converted HTML content with preserved line breaks
    return preservedContent;
    }

    closeModal(){
        this.$emit('update:isShowNotificationPreviewModal', false);
    }
    
  
    private changeDateFormat(inputDate: string): string {
           const utcDate = new Date(inputDate);
           const year = utcDate.getFullYear();
           const month = (utcDate.getMonth() + 1).toString().padStart(2, '0'); 
           const day = utcDate.getDate().toString().padStart(2, '0');
           const newDateFormat = `${year}/${month}/${day}`;
           return newDateFormat;
    }
}